import { Box, Divider, Stack, Typography } from "@mui/material"

import { ReactComponent as HappySmile } from "static/svg/smiles/happy.svg"
import { ReactComponent as NeutralSmile } from "static/svg/smiles/neutral.svg"
import { ReactComponent as BadSmile } from "static/svg/smiles/bad.svg"
// import BadStatus from "./Bad"
// import WarningStatus from "./Warning"
// import SuccessStatus from "./Success"
import DiseaseCode from "../../shared/DiseaseCode"

const Diseases = (props) => {
  const { data } = props

  const getSmile = (symptoms) => {
    const dangerMatches = symptoms.some((item) => item.danger === "high")
    const warningMatches = symptoms.some((item) => item.danger === "medium")

    if (dangerMatches) {
      return <BadSmile />
    } else if (warningMatches) {
      return <NeutralSmile />
    } else {
      return <HappySmile />
    }
  }

  return (
    <Stack>
      {data.map((item, i) => (
        <Box key={i}>
          <Box sx={{ display: "flex", justifyContent: "space-between", my: 1 }}>
            <Typography>{item.disease.name}</Typography>
            <Box sx={{ display: "flex", alignItems: "center", ml: 1 }}>
              <DiseaseCode icd10={item.disease.icd10} />
              <Box sx={{ ml: 1, mt: 0.5 }}>{getSmile(item.disease.symptoms)}</Box>
            </Box>
          </Box>
          {i !== data.length - 1 && <Divider />}
        </Box>
      ))}
    </Stack>
  )
}

export default Diseases
